module.exports = __webpack_public_path__ + "img/inboxgroup.9ffc4cfd.svg";